// extracted by mini-css-extract-plugin
module.exports = {"housingHelperLink":"HousingHelperBanner_housingHelperLink__ttPF9"};